import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Home, Plus, User, LogOut, Coins, Shield } from 'lucide-react';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { lang, toggleLanguage, t } = useLanguage();

  const navItems = [
    { path: '/home', icon: <Home className="w-5 h-5" />, label: t('home') },
    { path: '/create-room', icon: <Plus className="w-5 h-5" />, label: 'Create Room' },
    { path: '/profile', icon: <User className="w-5 h-5" />, label: t('profile') },
  ];

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <nav data-testid="navbar" className="fixed top-0 left-0 right-0 z-40 glass border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => navigate('/home')} className="flex items-center gap-2">
          <span className="text-xl font-bold gradient-text">FlirtyLive</span>
        </button>
        <div className="flex items-center gap-1">
          {navItems.map(item => (
            <button key={item.path} data-testid={`nav-${item.path.slice(1)}`} onClick={() => navigate(item.path)}
              className={`px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2 transition-all ${location.pathname === item.path ? 'bg-[#FF007F]/15 text-[#FF007F]' : 'text-slate-400 hover:text-white hover:bg-white/5'}`}>
              {item.icon}
              <span className="hidden sm:inline">{item.label}</span>
            </button>
          ))}
          {user?.role === 'admin' && (
            <button data-testid="nav-admin" onClick={() => navigate('/admin')}
              className={`px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2 transition-all ${location.pathname === '/admin' ? 'bg-amber-500/15 text-amber-400' : 'text-amber-400/60 hover:text-amber-400 hover:bg-white/5'}`}>
              <Shield className="w-5 h-5" />
              <span className="hidden sm:inline">Admin</span>
            </button>
          )}
        </div>
        <div className="flex items-center gap-3">
          {user && (
            <div className="flex items-center gap-2 glass px-3 py-1.5 rounded-full text-sm">
              <Coins className="w-4 h-4 text-amber-400" />
              <span className="font-medium">{user.tokens}</span>
            </div>
          )}
          <button data-testid="nav-lang-toggle" onClick={toggleLanguage}
            className="px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 text-sm transition-all">
            {lang === 'en' ? '\u{1F1EE}\u{1F1F9}' : '\u{1F1EC}\u{1F1E7}'}
          </button>
          {user && (
            <button data-testid="nav-logout" onClick={handleLogout}
              className="p-2 rounded-full bg-white/5 hover:bg-red-500/20 hover:text-red-400 transition-all">
              <LogOut className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
